import sscache from 'session-storage-cache';

type AmazonProfile = {
  email: string;
  firstName: string;
  lastName: string;
};

export const getAmazonProfile = (): Promise<AmazonProfile> =>
  new Promise((resolve, reject) => {
    if (!window.amazon) return reject('Amazon SDK is not loaded.');

    const accessToken = sscache.get('amazonAccessToken');

    if (!accessToken) return reject('No Amazon access token found.');

    window.amazon.Login.retrieveProfile(accessToken, response =>
      response.success && response.profile
        ? resolve({
            email: response.profile.PrimaryEmail,
            firstName: response.profile.Name.split(' ')[0],
            lastName: response.profile.Name.split(' ').slice(1).join(' ')
          })
        : reject('Failed to get Amazon profile.')
    );
  });
